import React from 'react';
import {
  Drawer as MuiDrawer,
  Divider,
  Box
} from '@mui/material';
import { styled, Theme, CSSObject, SxProps } from '@mui/material/styles';
import beforepayLogo from "@/assets/beforepay-logo.png";
import { LayoutRightIcon } from "@/components/UI/Icons";

const drawerWidth = 240;

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});
interface DrawerProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  variant: string;
  sx?: SxProps<Theme>
}

export const Drawer: React.FC<DrawerProps> = ({ open, onClose, children }) => {
  return (
    <StyledDrawer  variant="permanent"
       open={open}>
      <DrawerHeader sx={{ display: "flex", justifyContent: "space-between", alignItems: "center"}}>
        {open && (
          <Box sx={{ pl: 2 }}>
            <img src={beforepayLogo} alt="Beforepay logo" />
          </Box>
        )}
        <LayoutRightIcon
          onClick={onClose}
          sx={{
            cursor: 'pointer',
            ml: open ? 0 : 'auto',
            mr: open ? 0 : 'auto',
            transform: open ? 'rotate(180deg)' : 'none',
            transition: 'transform 0.2s',
          }}
        />
      </DrawerHeader>
      <Divider />
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', height: '100%' }}>
        {children}
      </Box>
    </StyledDrawer>
  );
};

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const StyledDrawer = styled(MuiDrawer, {
    shouldForwardProp: (prop) => prop !== 'open',
  })<{ open: boolean }>(({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': {
        ...openedMixin(theme),
        backgroundColor: '#F6F8F9',
      },
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': {
        ...closedMixin(theme),
        backgroundColor: '#F6F8F9',
      },
    }),
  }));
